var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17.001,
    viewBox: "0 0 22 17.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M13536.259,5196a3.252,3.252,0,0,1-3.259-3.237v-10.523a3.254,3.254,0,0,1,3.259-3.24h13.854a3.253,3.253,0,0,1,3.258,3.24v.807h-1.223v-.807a2.033,2.033,0,0,0-2.035-2.025h-13.854a2.033,2.033,0,0,0-2.036,2.025v10.523a2.03,2.03,0,0,0,2.036,2.022h13.854a2.03,2.03,0,0,0,2.035-2.022v-.81h-8.555a1.625,1.625,0,0,1-1.631-1.62v-5.667a1.624,1.624,0,0,1,1.631-1.617h9.777a1.623,1.623,0,0,1,1.63,1.617v5.667a1.624,1.624,0,0,1-1.63,1.62v.81a3.251,3.251,0,0,1-3.258,3.237Zm6.927-11.334v5.667a.406.406,0,0,0,.407.4h9.777a.407.407,0,0,0,.408-.4v-5.667a.405.405,0,0,0-.408-.4h-9.777A.4.4,0,0,0,13543.186,5184.666Zm1.223,2.835a1.222,1.222,0,1,1,1.223,1.215A1.219,1.219,0,0,1,13544.408,5187.5Z",
    transform: "translate(-13533 -5178.999)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.9de634be9250292f79671bb76d006924.svg";
export { ForwardRef as ReactComponent };